// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1N3GO","header":"ReportDetails_header__1I0vm","title":"ReportDetails_title__nEK1Z","left":"ReportDetails_left__2t01m"};